import { Injectable } from '@angular/core';

import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
    apiUrl: string = environment.apiUrl;
    user: User;

    constructor(private httpClient: HttpClient,) {
    }
    login(userid: string, password: string) {
        return this.httpClient.post<any>(`${this.apiUrl}auth/login`, { userId: userid, password: password });
        // .pipe(map(user => {
        //     debugger;
        //     if (user) {
        //         localStorage.setItem('user', JSON.stringify(user));
        //         localStorage.setItem('access_token', JSON.stringify(user));
        //     }
        //     return user;
        // }));
    }
    /**
     * Returns the current user
     */
    public currentUser() {
        return localStorage.getItem("user")
    }
    public currentUserToken() {
        return localStorage.getItem("access_token")
    }
    public currentUserData() {
        return localStorage.getItem("user_data")
    }

    getApiVersion() {
        return this.httpClient.get<any>(`${this.apiUrl}auth/version`);
    }

    logout(isheader = true) {

        localStorage.removeItem('menus');
        localStorage.removeItem('user_for');
        localStorage.removeItem('roleNames');
        localStorage.removeItem('user_data');
        localStorage.removeItem('access_token');

    }



}
